export interface TrafficSignalNode {
  id: number;
  position: [number, number]; // [lng, lat]
  tags: Record<string, string>;
}

export const SANTA_COLOMA_CENTER: [number, number] = [2.2094, 41.4505];
export const SANTA_COLOMA_BOUNDS: [[number, number], [number, number]] = [
  [2.190, 41.438],
  [2.228, 41.463]
];
export const SANTA_COLOMA_ZOOM = 15;

export const santaColomaSignals: TrafficSignalNode[] = [
  {
    "id": 359691769,
    "position": [
      2.2101647,
      41.4447054
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 365123817,
    "position": [
      2.2081392,
      41.4577653
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 370608856,
    "position": [
      2.2048892,
      41.4544097
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 370608901,
    "position": [
      2.2085125,
      41.4570653
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 370608910,
    "position": [
      2.2082654,
      41.4578549
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 370608915,
    "position": [
      2.205,
      41.4555443
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 370608917,
    "position": [
      2.2047338,
      41.4553567
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 428026393,
    "position": [
      2.2190917,
      41.4457547
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 600061544,
    "position": [
      2.2092194,
      41.4511633
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 611299265,
    "position": [
      2.2104709,
      41.4443795
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 1141503277,
    "position": [
      2.2058218,
      41.4436034
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 1341444419,
    "position": [
      2.2061187,
      41.4519582
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 1371264422,
    "position": [
      2.198731,
      41.4537488
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 1489990576,
    "position": [
      2.2200214,
      41.4466434
    ],
    "tags": {
      "crossing": "no",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 2857808096,
    "position": [
      2.2046355,
      41.4526895
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 2857821368,
    "position": [
      2.2086554,
      41.4571805
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 3040841186,
    "position": [
      2.2104676,
      41.4447114
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 3040841188,
    "position": [
      2.2100867,
      41.4444519
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 3158182902,
    "position": [
      2.2195402,
      41.4461826
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 3209362418,
    "position": [
      2.197338,
      41.4476348
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 4436287104,
    "position": [
      2.1980824,
      41.4465357
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 4569356442,
    "position": [
      2.2086852,
      41.4438872
    ],
    "tags": {
      "crossing": "no",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 4569356445,
    "position": [
      2.2085846,
      41.4436079
    ],
    "tags": {
      "crossing": "no",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 4590628702,
    "position": [
      2.2066172,
      41.4436327
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 4590628717,
    "position": [
      2.2063497,
      41.4434636
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 5124632803,
    "position": [
      2.205103,
      41.4545448
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 5301259065,
    "position": [
      2.2060774,
      41.4517847
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 5580431849,
    "position": [
      2.2193756,
      41.4540209
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 5675594311,
    "position": [
      2.2176312,
      41.4445306
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 5675596314,
    "position": [
      2.2212271,
      41.4476195
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 5675596317,
    "position": [
      2.2211916,
      41.4475674
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 5675596319,
    "position": [
      2.2206163,
      41.4470408
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 5675596320,
    "position": [
      2.2208441,
      41.4472336
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 5675596321,
    "position": [
      2.2200329,
      41.4465098
    ],
    "tags": {
      "highway": "traffic_signals"
    }
  },
  {
    "id": 5675596322,
    "position": [
      2.2198487,
      41.4464624
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 5675596323,
    "position": [
      2.2196057,
      41.4462313
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 5675596325,
    "position": [
      2.2190461,
      41.4456977
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 5675596326,
    "position": [
      2.2183419,
      41.4449134
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 5675596327,
    "position": [
      2.2185288,
      41.4448994
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 5675596328,
    "position": [
      2.2185456,
      41.4450571
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 5675596329,
    "position": [
      2.2180812,
      41.4446643
    ],
    "tags": {
      "highway": "traffic_signals"
    }
  },
  {
    "id": 5675596330,
    "position": [
      2.2177836,
      41.4445513
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 5675596331,
    "position": [
      2.2175828,
      41.4443567
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 6038201075,
    "position": [
      2.2208143,
      41.4470457
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 6119950626,
    "position": [
      2.2203548,
      41.4522274
    ],
    "tags": {
      "crossing": "no",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 6119950627,
    "position": [
      2.2200799,
      41.4524025
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 6119950628,
    "position": [
      2.2203321,
      41.4524341
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 6119950629,
    "position": [
      2.2212239,
      41.4526524
    ],
    "tags": {
      "highway": "traffic_signals"
    }
  },
  {
    "id": 6119950631,
    "position": [
      2.2202968,
      41.4520942
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 6141567725,
    "position": [
      2.2169758,
      41.4437763
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 6141567726,
    "position": [
      2.2168957,
      41.4436244
    ],
    "tags": {
      "highway": "traffic_signals"
    }
  },
  {
    "id": 6815991629,
    "position": [
      2.2058721,
      41.4435633
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 7417371878,
    "position": [
      2.2099843,
      41.4443375
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 7417371879,
    "position": [
      2.2099836,
      41.4447361
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 7417371880,
    "position": [
      2.2105478,
      41.4448359
    ],
    "tags": {
      "button_operated": "no",
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "tactile_paving": "no",
      "traffic_signals:direction": "forward",
      "traffic_signals:sound": "yes",
      "traffic_signals:vibration": "no"
    }
  },
  {
    "id": 7417371883,
    "position": [
      2.2086666,
      41.4434517
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 7417371884,
    "position": [
      2.2088406,
      41.4439805
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 7417379585,
    "position": [
      2.2082436,
      41.4437266
    ],
    "tags": {
      "crossing": "no",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 7417379586,
    "position": [
      2.2082659,
      41.4438638
    ],
    "tags": {
      "crossing": "no",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 7417379587,
    "position": [
      2.2080341,
      41.444013
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 7830020110,
    "position": [
      2.21107,
      41.4450051
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 7830020111,
    "position": [
      2.2108301,
      41.4449596
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 8357867922,
    "position": [
      2.2028873,
      41.4497672
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 8357867938,
    "position": [
      2.2031622,
      41.44939
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 8361108743,
    "position": [
      2.2065159,
      41.4508157
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 8461538521,
    "position": [
      2.2066255,
      41.443262
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 8461538522,
    "position": [
      2.2064146,
      41.4434306
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 8514437732,
    "position": [
      2.2182804,
      41.4515983
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 8514438013,
    "position": [
      2.2068582,
      41.4509232
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 8528851101,
    "position": [
      2.1978395,
      41.4474989
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 8528896471,
    "position": [
      2.1979487,
      41.4469589
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 8528896472,
    "position": [
      2.1983286,
      41.4469535
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 8528896474,
    "position": [
      2.1983282,
      41.4466827
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 8528964647,
    "position": [
      2.1994993,
      41.4451376
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 8528964648,
    "position": [
      2.1989651,
      41.4452557
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 8528964649,
    "position": [
      2.1988443,
      41.4449282
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 8530316968,
    "position": [
      2.2024154,
      41.4431121
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 8530316969,
    "position": [
      2.2031563,
      41.4431924
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 8545709833,
    "position": [
      2.2048833,
      41.4524996
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 8545709834,
    "position": [
      2.2045633,
      41.4525805
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal"
    }
  },
  {
    "id": 8545709835,
    "position": [
      2.2058672,
      41.4519408
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals": "signal",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 8667136188,
    "position": [
      2.2179287,
      41.45148
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 9349008541,
    "position": [
      2.2047175,
      41.4556134
    ],
    "tags": {
      "button_operated": "no",
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "tactile_paving": "no",
      "traffic_signals:sound": "no",
      "traffic_signals:vibration": "no"
    }
  },
  {
    "id": 9349008542,
    "position": [
      2.2029811,
      41.4564252
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "both"
    }
  },
  {
    "id": 9349008544,
    "position": [
      2.202226,
      41.456965
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "both"
    }
  },
  {
    "id": 9349008546,
    "position": [
      2.2016812,
      41.4573849
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 9349008547,
    "position": [
      2.2015907,
      41.4577194
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals"
    }
  },
  {
    "id": 9349008548,
    "position": [
      2.2011904,
      41.4576042
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 9349008549,
    "position": [
      2.2014196,
      41.4577781
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 9349008555,
    "position": [
      2.1984161,
      41.4574864
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "both"
    }
  },
  {
    "id": 9349008556,
    "position": [
      2.1978517,
      41.4574482
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals"
    }
  },
  {
    "id": 9349008557,
    "position": [
      2.1977488,
      41.4573986
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals"
    }
  },
  {
    "id": 9350744814,
    "position": [
      2.2035864,
      41.45453
    ],
    "tags": {
      "button_operated": "no",
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "tactile_paving": "no",
      "traffic_signals:sound": "no",
      "traffic_signals:vibration": "no"
    }
  },
  {
    "id": 9350744815,
    "position": [
      2.2051801,
      41.4556753
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "tactile_paving": "no",
      "traffic_signals:sound": "yes"
    }
  },
  {
    "id": 9350744816,
    "position": [
      2.2050178,
      41.4553517
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals"
    }
  },
  {
    "id": 9350815635,
    "position": [
      2.208278,
      41.4475006
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals"
    }
  },
  {
    "id": 9350815636,
    "position": [
      2.2081774,
      41.4473174
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals"
    }
  },
  {
    "id": 9350815637,
    "position": [
      2.2052763,
      41.4470854
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "both"
    }
  },
  {
    "id": 9350815638,
    "position": [
      2.2048003,
      41.447593
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "both"
    }
  },
  {
    "id": 9350815641,
    "position": [
      2.2041371,
      41.448297
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "both"
    }
  },
  {
    "id": 9350815642,
    "position": [
      2.2036445,
      41.4489772
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "both"
    }
  },
  {
    "id": 9350815643,
    "position": [
      2.2032329,
      41.4494226
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 9350815645,
    "position": [
      2.2033178,
      41.4497386
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 9350815646,
    "position": [
      2.2029389,
      41.4497964
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 9350815647,
    "position": [
      2.2024308,
      41.4503235
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "both"
    }
  },
  {
    "id": 9350815663,
    "position": [
      2.2006584,
      41.4523836
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals"
    }
  },
  {
    "id": 9350840949,
    "position": [
      2.2072853,
      41.4449744
    ],
    "tags": {
      "button_operated": "no",
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "tactile_paving": "yes",
      "traffic_signals:direction": "backward",
      "traffic_signals:sound": "yes",
      "traffic_signals:vibration": "no"
    }
  },
  {
    "id": 9350840951,
    "position": [
      2.2065269,
      41.4457631
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "both"
    }
  },
  {
    "id": 9350840952,
    "position": [
      2.205823,
      41.4465013
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "both"
    }
  },
  {
    "id": 10113782956,
    "position": [
      2.2033438,
      41.4496978
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 10189568659,
    "position": [
      2.1980327,
      41.4478812
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10189568660,
    "position": [
      2.1980006,
      41.447952
    ],
    "tags": {
      "bicycle": "yes",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10189568661,
    "position": [
      2.1999959,
      41.4484915
    ],
    "tags": {
      "bicycle": "yes",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10189568662,
    "position": [
      2.1999574,
      41.4485496
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 10189568665,
    "position": [
      2.2004887,
      41.4487262
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10189568666,
    "position": [
      2.2004407,
      41.4487999
    ],
    "tags": {
      "bicycle": "yes",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10189568667,
    "position": [
      2.200947,
      41.4488857
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 10189568668,
    "position": [
      2.2009729,
      41.4488396
    ],
    "tags": {
      "bicycle": "yes",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10189568669,
    "position": [
      2.2011073,
      41.4489695
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals"
    }
  },
  {
    "id": 10189568671,
    "position": [
      2.2011048,
      41.4489354
    ],
    "tags": {
      "bicycle": "yes",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10189568679,
    "position": [
      2.2028432,
      41.4495103
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10189568692,
    "position": [
      2.2028069,
      41.4495243
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 10195655150,
    "position": [
      2.2048613,
      41.4502239
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10195655151,
    "position": [
      2.204879,
      41.4501975
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10195655152,
    "position": [
      2.2051493,
      41.4503655
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10195655153,
    "position": [
      2.2050899,
      41.450174
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10195655154,
    "position": [
      2.2049239,
      41.4504553
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10195655163,
    "position": [
      2.2065428,
      41.4507738
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10195655165,
    "position": [
      2.2065545,
      41.4510713
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10195655166,
    "position": [
      2.2051693,
      41.4503371
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 10195726505,
    "position": [
      2.2088567,
      41.4511328
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10195726509,
    "position": [
      2.2088574,
      41.4511062
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10195726511,
    "position": [
      2.2093137,
      41.4509656
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10195726515,
    "position": [
      2.2068235,
      41.4509584
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10195753817,
    "position": [
      2.2079435,
      41.4510121
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 10565331756,
    "position": [
      2.1980414,
      41.453831
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 11243130305,
    "position": [
      2.1973779,
      41.4545083
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 11285774443,
    "position": [
      2.2080866,
      41.4436899
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals"
    }
  },
  {
    "id": 11291107827,
    "position": [
      2.2056184,
      41.4437278
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals"
    }
  },
  {
    "id": 11291107828,
    "position": [
      2.2054296,
      41.4434502
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "both"
    }
  },
  {
    "id": 11293237602,
    "position": [
      2.207462,
      41.4447729
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 11293237603,
    "position": [
      2.2076309,
      41.444981
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 11390006561,
    "position": [
      2.1986311,
      41.4533942
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 11390006562,
    "position": [
      2.1987462,
      41.4534088
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 11390006565,
    "position": [
      2.1973272,
      41.4545414
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 11843560339,
    "position": [
      2.1980369,
      41.4463485
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 12194979598,
    "position": [
      2.1996516,
      41.4431451
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 12577103870,
    "position": [
      2.2217185,
      41.4528079
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 12577103871,
    "position": [
      2.2216159,
      41.4527356
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 12577103872,
    "position": [
      2.2212195,
      41.4529176
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 12577103873,
    "position": [
      2.2209556,
      41.4530734
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 12577103874,
    "position": [
      2.2206107,
      41.4532593
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 12577103875,
    "position": [
      2.2208707,
      41.4533349
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 12577103876,
    "position": [
      2.2215309,
      41.4542086
    ],
    "tags": {
      "highway": "traffic_signals"
    }
  },
  {
    "id": 12577103877,
    "position": [
      2.2214524,
      41.4542962
    ],
    "tags": {
      "highway": "traffic_signals"
    }
  },
  {
    "id": 12577103879,
    "position": [
      2.2193403,
      41.4542577
    ],
    "tags": {
      "highway": "traffic_signals"
    }
  },
  {
    "id": 12577103880,
    "position": [
      2.2203413,
      41.4550264
    ],
    "tags": {
      "highway": "traffic_signals"
    }
  },
  {
    "id": 12577103881,
    "position": [
      2.2205428,
      41.4550422
    ],
    "tags": {
      "highway": "traffic_signals"
    }
  },
  {
    "id": 12577103882,
    "position": [
      2.2216013,
      41.4557131
    ],
    "tags": {
      "highway": "traffic_signals"
    }
  },
  {
    "id": 12577103883,
    "position": [
      2.2216664,
      41.4559022
    ],
    "tags": {
      "highway": "traffic_signals"
    }
  },
  {
    "id": 13104075855,
    "position": [
      2.1979635,
      41.4478569
    ],
    "tags": {
      "crossing": "traffic_signals",
      "highway": "traffic_signals",
      "traffic_signals:direction": "backward"
    }
  },
  {
    "id": 13104075856,
    "position": [
      2.1979957,
      41.4477978
    ],
    "tags": {
      "bicycle": "yes",
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 13104159170,
    "position": [
      2.1971478,
      41.4436492
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  },
  {
    "id": 13104159171,
    "position": [
      2.1974684,
      41.4445982
    ],
    "tags": {
      "highway": "traffic_signals",
      "traffic_signals:direction": "forward"
    }
  }
];
